export const messages = state => state.messages
export const modals = state => state.modals
